import Tracker from '@travelata-libs/tracker';
import { useTravelataAppConfig } from '@/shared/composables/useTravelataAppConfig';
import { container } from '@/shared/di/Container';
import { MARKETING_CLIENT_TOKEN } from '@/shared/di/tokens';
import { getClientUuid } from '@/shared/lib/clientUuid';

function getHostMarketingClient(): Tracker | null {
  return container.has(MARKETING_CLIENT_TOKEN) ? container.resolve(MARKETING_CLIENT_TOKEN) : null;
}

export async function createMarketingClient(): Promise<Tracker | null> {
  try {
    const hostMarketingClient = getHostMarketingClient();
    if (hostMarketingClient) return hostMarketingClient;

    const { apiGatewayUrl } = useTravelataAppConfig();
    return new Tracker({ config: { apiGatewayUrl }, clientUuid: getClientUuid() || undefined });
  } catch {
    return null;
  }
}
